import React, { forwardRef } from 'react';
import { Input as BaseInput } from '../../../Form/Input';
import { SelectV2Types } from '../../SelectV2.types';
import { styled } from '../../../../styles';

export const Input = forwardRef<HTMLDivElement, SelectV2Types.SelectInputProps>(
  ({ style, autoComplete, state, ...rest }, ref) => {
    const isAutocompleteOn = autoComplete === 'on';
    const notDisabledCursor = isAutocompleteOn ? 'text' : 'pointer';
    const cursor = rest.disabled ? 'default' : notDisabledCursor;
    const hasSingleSelectedValueAndIsNotOpen = !state.multiple && !!state.selectedOption && !state.menuOpen;
    return (
      <StyledAutocompleteInput
        ref={ref}
        slotProps={{
          input: {
            autoComplete: undefined,
            style: {
              ...style,
              cursor
            }
          },
          htmlInput: {
            readOnly: !isAutocompleteOn || hasSingleSelectedValueAndIsNotOpen,
            style: {
              pointerEvents: !isAutocompleteOn || hasSingleSelectedValueAndIsNotOpen ? 'none' : undefined
            }
          }
        }}
        style={{ cursor }}
        {...rest}
      />
    );
  }
);

export const StyledAutocompleteInput = styled(BaseInput)`
    .MuiInputBase-root {
        height: auto;
        display: grid;
        grid-template-areas: "input end-adornment";
        grid-template-rows: auto;
        grid-template-columns: 1fr max-content;
        padding-left: ${({ theme }) => theme.spacingSize.m};
        border-color: ${({ error, theme }) => (error ? theme.tokens.colorAlert : undefined)};

        &:has(.MuiInputAdornment-positionStart) {
            grid-template-areas: "start-adornment input end-adornment";
            grid-template-columns: minmax(40%, max-content) 1fr max-content;
        }
        &:has(.multi-selection) {
            grid-template-areas: 
                    "start-adornment end-adornment"
                    "input end-adornment";
            grid-template-columns: 1fr max-content;
                    
        }
        
        input, input:focus, input:active {
            grid-area: input;
            padding-left: 0;
            
            &.MuiInput-input:placeholder-shown {
                text-overflow: ellipsis;
                white-space: nowrap !important;
            }
        }
        [selected-value] {
            margin-top: -1px
        }
        
        .MuiInputAdornment-positionStart {
            grid-area: start-adornment;
            padding-bottom: 0;
            color: ${({ theme }) => theme.tokens.colorOnSurface};
        }
        .MuiInputAdornment-positionEnd {
            grid-area: end-adornment;
        }
        
        .multi-selection {
            display: block;
            max-height: none;
            min-width: 0;
            height: auto;
        }
    }
`;
